import { render, staticRenderFns } from "./GenerateWallet.vue?vue&type=template&id=30e8ddd3&scoped=true&"
import script from "./GenerateWallet.vue?vue&type=script&lang=js&"
export * from "./GenerateWallet.vue?vue&type=script&lang=js&"
import style0 from "./GenerateWallet.vue?vue&type=style&index=0&id=30e8ddd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e8ddd3",
  null
  
)

export default component.exports